<template>
	<div v-if="ready" class="row-container">
		<iframe
			:src="src"
			marginheight="0"
			marginwidth="0"
			frameborder="0"
		></iframe>
	</div>
	<v-row v-else>
		<v-col align="center">
			<v-progress-circular size="84" :indeterminate="true" />
			<h3 class="pt-6">Loading...</h3>
		</v-col>
	</v-row>
</template>

<style lang="scss" scoped>
.row-container {
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	overflow: hidden;

	iframe {
		flex-grow: 1;
	}
}
</style>

<script>
import domo from "@/utils/domo";

export default {
	props: ["communityId"],

	data: () => ({
		ready: false,
		cardUrl: "https://k4connect.domo.com/embed/card/979479443",
	}),

	computed: {
		src() {
			const filters = [
				{
					column: "Community ID",
					dataType: "string",
					operand: "IN",
					values: [this.communityId],
				},
			];
			return `${this.cardUrl}?pfilters=${JSON.stringify(filters)}`;
		},
	},

	async created() {
		this.ready = await domo.hasCookieSupport();

		// Redirect browser to domo bounce page. Domo, in turn, will redirect
		// back to us, at our current URL.
		if (!this.ready) {
			this.$log(
				`Third-party cookie support missing. Redirecting to Domo bounce page.`
			);
			domo.bouncePage();
		}
	},
};
</script>
